export default __webpack_public_path__ + "static/media/blocktower.9e94dd74.svg";